<script>
    import TheGuaranteeList from "@main/packages/TheGuaranteeList";
    import { GUARANTEE_BREAKPOINT } from "@picooc/settings/breakpoints";

    export default {
        name: "GuaranteeList",
        components: { TheGuaranteeList },
        data() {
            return {
                breakpoints: GUARANTEE_BREAKPOINT,
            };
        },
    };
</script>

<template>
    <the-guarantee-list
        :breakpoints="breakpoints"
        text-for-brand="Picooc"
        text-for-year="до 2 лет"
        :custom-text="{
            guarantee:
                '12&nbsp;месяцев на&nbsp;массажеры и&nbsp;24&nbsp;месяца на&nbsp;умные весы и&nbsp;монитор давления',
        }"
    ></the-guarantee-list>
</template>
